// src/components/Footer.js
import React from "react";
import "./Footer.css";

// Import your logo and social icons
import logo from "../assets/logo.png";
import twitterIcon from "../assets/twitter-x-icon.png";
import facebookIcon from "../assets/facebook-icon.png";
import instagramIcon from "../assets/instagram-icon.png";
import linkedinIcon from "../assets/512px-LinkedIn_logo_initials.png";

const Footer = () => {
  return (
    <footer className="footer-section">
      {/* The main container will now be a 2-part grid: About + Other Links */}
      <div className="footer-container container">
        {/* Column 1: Logo and Socials */}
        <div className="footer-column about-us">
          <img src={logo} alt="Dr. Doodley Logo" className="footer-logo" />
        </div>

        {/* FIX: Wrap the other three columns in a 'links-grid' div */}
        <div className="footer-links-grid">
          {/* Column 2: Contact Info */}
          <div className="footer-column">
            <h4 className="footer-title">
              Contact <span className="title-highlight"> Us </span>
            </h4>
            <p className="contact-info">
              <a
                href="#mail"
                onClick={() => {
                  window.open("mailto:care@doodley.in");
                }}
              >
                <span role="img" aria-label="email">
                  📧
                </span>{" "}
                care@doodley.in
              </a>
            </p>
            <p className="contact-info">
              <a
                href="#phone"
                onClick={() => {
                  window.open("tel:+91 9902356133");
                }}
              >
                <span role="img" aria-label="phone">
                  📞
                </span>{" "}
                +91 99023 56133
              </a>
            </p>
          </div>

          {/* Column 3: Opening Hours */}
          {/* <div className="footer-column">
            <h4 className="footer-title">Opening <span className='title-highlight'>Hours</span></h4>
            <p><strong>Mon to Fri :</strong> 10am - 7pm</p>
            <p><strong>Sat :</strong> 10am - 4pm</p>
            <p><strong>Sun:</strong> 9am - 2pm</p>
          </div> */}

          {/* Column 4: Useful Links */}
          <div className="footer-column">
            <h4 className="footer-title">
              Useful <span className="title-highlight">Links</span>
            </h4>
            <a target="_blank" rel="noreferrer" href="https://doodley.in/terms">
              Terms and conditions
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://doodley.in/refund"
            >
              Refund Policy
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://doodley.in/privacy-policy"
            >
              Privacy Policy
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://doodley.in/shipping-policy"
            >
              Shipping Policy
            </a>
            <a target="_blank" rel="noreferrer" href="https://doodley.in/help">
              Support
            </a>
          </div>
        </div>

        {/* <h4 className="footer-title">
          Follow <span className="title-highlight">Us</span>
        </h4> */}
        {/* <div className="social-icons">
          <a
            href="https://x.com/Doodleypets?t=yUBLjU6-UgicYFMM4hfhrQ&s=08"
            className="social-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={twitterIcon} alt="Twitter" />
          </a>
          <a
            href="https://www.facebook.com/people/Doodley-Pets/61553900861186/"
            className="social-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebookIcon} alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/doodleypets/?igsh=MW50aGI0MmZjaHIweQ%3D%3D#"
            className="social-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagramIcon} alt="Instagram" />
          </a>
          <a
            href="https://www.linkedin.com/company/drdoodley/"
            className="social-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedinIcon} alt="LinkedIn" />
          </a>
        </div> */}
      </div>

      <div className="footer-bottom">
        <p>© 2025 Doodley (Doodley.in)</p>
      </div>
    </footer>
  );
};

export default Footer;
